import React from "react";
import { ShieldCheck, Search, Wrench, Clock, CircleCheck, ArrowRight, Ruler, Hammer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Ճշգրիտ LiDAR տվյալներ",
  description: "Մենք օգտագործում ենք բարձր լուծաչափով LiDAR սկանավորում՝ տեղանքի առավելագույն ճշգրտությամբ թվային մոդելներ ստեղծելու համար:",
  icon: ShieldCheck
}, {
  title: "Ֆոտոգրամետրիկ մշակում",
  description: "Օդալուսանկարահանման տվյալների խորը վերլուծություն՝ բարձրորակ DSM և DTM մոդելների ստացման նպատակով:",
  icon: Search
}, {
  title: "Ծրագրային համատեղելիություն",
  description: "Մեր ստեղծած մոդելները լիովին համատեղելի են ArcGIS, QGIS և AutoCAD մասնագիտական ծրագրային փաթեթների հետ:",
  icon: Wrench
}];
const processSteps = [{
  step: "01",
  title: "Տվյալների Հավաքագրում",
  description: "LiDAR կամ ռադարային սկանավորում և օդալուսանկարահանում:",
  icon: Ruler
}, {
  step: "02",
  title: "Կետային Ամպի Մշակում",
  description: "Ստացված տվյալների զտում և երկրաչափական ուղղումների իրականացում:",
  icon: Search
}, {
  step: "03",
  title: "Մոդելավորում (DSM/DTM)",
  description: "Ռելիեֆի և տեղանքի թվային մակերևույթների վերջնական կառուցում:",
  icon: Hammer
}, {
  step: "04",
  title: "Որակի Ստուգում",
  description: "Ճշգրտության վերջնական ստուգում և հաշվետվության տրամադրում:",
  icon: CircleCheck
}];
export default function ServiceDetailsFrameRepair() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: featuresRef,
    isVisible: isFeaturesVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="252483" id="service-details" className="bg-background text-foreground py-16 md:py-24 overflow-hidden light">

      <div className="page-container">

        

        {}

        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>

          

          <h2 className="text-foreground font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-6">

            Ռելիեֆի և տեղանքի թվային մոդելների ստեղծում (DSM/DTM)

          </h2>

          <p className="text-muted-foreground text-lg md:text-xl font-default">

            Ստացեք տեղանքի բարձր ճշգրտության թվային պատկերներ՝ օգտագործելով LiDAR և ֆոտոգրամետրիայի ժամանակակից տեխնոլոգիաները:

          </p>

        </div>



        {}

        <div ref={contentRef} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20 transition-all duration-700 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>

          <div className="relative rounded-lg overflow-hidden shadow-lg group">

            

<img src="https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/image254.png" alt="DSM DTM Digital Terrain Modeling" className="w-full h-auto transform group-hover:scale-105 transition-transform duration-700 rounded-lg" loading="lazy" />            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-primary/90 to-transparent p-6 z-20">

              <div className="flex items-center gap-3 text-primary-foreground">

                <Clock className="size-6 text-secondary" />

                <div>

                  

                  

                </div>

              </div>

            </div>

          </div>



          <div className="flex flex-col gap-8">

            <div>

              <h3 className="text-foreground font-default text-2xl font-bold mb-4">Մոդելավորման գործընթացը</h3>

              <p className="text-muted-foreground mb-6 font-default">

                Մենք կիրառում ենք բազմափուլային մշակման մեթոդաբանություն՝ ապահովելու համար տվյալների հավաստիությունը և տեխնիկական համապատասխանությունը:

              </p>

            </div>



            <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-border before:to-transparent">

              {processSteps.map((item, i) => <div key={i} data-index={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active">

                  <div className="flex items-center justify-center w-10 h-10 rounded-lg border-4 border-background bg-primary text-primary-foreground shadow-md shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10">

                    <item.icon className="size-4" />

                  </div>

                  <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-lg border border-border bg-card shadow-sm transition-all hover:shadow-md hover:border-primary/50">

                    <div className="flex items-center gap-2 mb-1">

                      <span className="text-xs font-bold text-primary-foreground bg-primary px-2 py-0.5 rounded-sm">Փուլ {item.step}</span>

                      <h4 className="font-default font-bold text-foreground">{item.title}</h4>

                    </div>

                    <p className="text-sm text-muted-foreground font-default">{item.description}</p>

                  </div>

                </div>)}

            </div>



            <div className="mt-4 p-6 bg-accent rounded-lg border border-primary/20">

              <div className="flex justify-between items-end mb-2">

                <span className="font-default font-bold text-foreground">Տվյալների Հավաստիություն</span>

                <span className="text-primary font-bold">99.9%</span>

              </div>

              <Progress value={99.9} className="h-2 bg-muted" />

              <p className="text-xs text-muted-foreground mt-3 text-center font-default">

                Մեր մոդելները համապատասխանում են միջազգային գեոդեզիական ստանդարտներին:

              </p>

            </div>

          </div>

        </div>



        <Separator className="my-16 bg-border" />



        {}

        <div ref={featuresRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 transition-all duration-700 delay-400 ease-out ${isFeaturesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>

          {features.map((feature, i) => <Card key={i} data-index={i} className="border-border shadow-md hover:shadow-lg transition-shadow duration-300 bg-card rounded-lg">

              <CardHeader>

                <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center mb-4 text-primary-foreground">

                  <feature.icon className="size-6" />

                </div>

                <CardTitle className="text-foreground font-default text-xl">{feature.title}</CardTitle>

              </CardHeader>

              <CardContent>

                <CardDescription className="text-base text-muted-foreground font-default">

                  {feature.description}

                </CardDescription>

              </CardContent>

            </Card>)}

        </div>



        {}

        <div className="text-center">

          <Button asChild size="lg" className="rounded-lg px-8 py-6 text-lg shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 transition-all bg-primary text-primary-foreground">

            

          </Button>

          

        </div>



      </div>

    </section>;
}